import { Divider } from '@/shared'
import { type IChildServiceDec } from '@App/types/servicesTypes'

import style from './ServiceInformation.module.scss'

interface IProps {
    tranferredService: IChildServiceDec
}

export const ServiceInformation = (props: IProps) => {
    const { tranferredService } = props
    const { path, name, code } = tranferredService

    const info = {
        path: ['Путь к услуге', path?.join(' / ') || ''],
        name: ['Наименование', name],
        code: ['Код услуги', code]
    }

    return (
        <div className={style.container}>
            <div className={style.header}>
                <span>Общие сведения об услуге</span>
            </div>
            <div className={style.divider}>
                <Divider />
            </div>
            <div className={style.infoWrapper}>
                {Object.values(info).map((item, idx) => {
                    const key = item[0]
                    const value = item[1]
                    return (
                        <div key={idx} className={style.item}>
                            <span>{key}</span>
                            <span>{value}</span>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
